module.exports = __webpack_public_path__ + "static/media/15f-05_Serie-Blanca-7-2015-300x200cm-oleo-sobre-papel.bbe70699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-05_Serie-Blanca-7-2015-300x200cm-oleo-sobre-papel.jpg
// module id = 178
// module chunks = 0